import { Typography } from '@material-ui/core'
import { Box, Paper } from '@material-ui/core'

import PhysicsWorld from '../../../logic/loop/PhysicsWorld'
import Player from '../../../logic/physics/Player'
import MGLoader from '../../../logic/saves/MGLoader'
import GameGlobals from '../GameGlobals'
import GamePage from '../GamePage'

export default function IntroductionPage() {

	return (
		<GamePage
			side={(
				<Paper elevation={0} style={{ marginRight: 16, height: 'fit-content' }}>
					<Box p="1rem" display="flex" flexDirection="column" gridGap="8px">
						<Typography variant="h5">Welcome to Magestro!!</Typography>
						<Typography variant="subtitle2" color="textSecondary" style={{ marginTop: -12 }}>The g is silent</Typography>
						<Typography variant="subtitle1">Begin by clicking on the player node<br />under the &quot;Physical World&quot;</Typography>
					</Box>
				</Paper>
			)}
			onLoaded={(world: PhysicsWorld) => {
				const player = new Player({
					world,

					x: 150,
					y: 150
				})

				MGLoader.loadCasterFromFile('Introduction.mg.json', player).then(() => {
					GameGlobals.setSelectedEntity(player)
				})

				world.add(player)

			}}
		/>
	)
}
